module.exports = __webpack_public_path__ + "static/media/speaker-xianyou-mobile.d6de82b6.jpg";